import { useEffect } from "react";
import { _ProjectSchedule } from "../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";

interface Props {
    idProjectSchedule: number;
}
export const TaskHistory = ({ idProjectSchedule }: Props) => {

    const _schedule = useDataBean(_ProjectSchedule);
    const { lista, setLista, bean, setBean, instance } = _schedule;

    useEffect(() => {
        getLista();
    }, [idProjectSchedule])

    const getLista = () => {
        instance.getProjectScheduleHistoryRender(1, 15, {IDProjectSchedule:idProjectSchedule}).then(
            (resp: any) => {
                setLista(resp.List);
            }
        )
    }
    const head = [
        { title: 'ID', property: 'IDProjectScheduleHistory', visible: false, mask: MASK_NUMBER },        
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Realizado por', property: 'IDAccountResponsibleName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean}></BasicTable>
            </div>
        </div>
    )
}